
export const PrefillerFields = () => {
  let triggers = document.querySelectorAll('[data-prefill]');
  triggers.forEach((trigger, i)=>{
    trigger.addEventListener('change', ( e ) => {
      e.preventDefault();
      let fieldName = e.target.dataset.prefill;
      let target = document.querySelector(`[name="${fieldName}"]`);
      target.value = e.target.value;
    });
  });
};

